"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorage = void 0;
const react_1 = require("react");
const __1 = require("..");
const storage_1 = require("../storage");
const reducer = {
    SET_VALUE: (state, { key, value, type }) => {
        const valueToStore = value instanceof Function ? value(state[key]) : value;
        (0, storage_1.setLocal)(key, valueToStore, type === 'session');
        return { [key]: valueToStore };
    },
};
const useStore = (key, defaultValue) => { var _a; return (0, __1.createStore)(reducer, { [key]: ((_a = (0, storage_1.getLocal)(key)) !== null && _a !== void 0 ? _a : defaultValue) })(key); };
function useStorage(type, key, defaultValue) {
    var _a;
    const [state, dispatch] = useStore(key, defaultValue);
    const setValue = (0, react_1.useCallback)((value) => dispatch('SET_VALUE', { key, value, type }), [dispatch, key, type]);
    (0, react_1.useEffect)(() => {
        var _a;
        const value = ((_a = (0, storage_1.getLocal)(key)) !== null && _a !== void 0 ? _a : defaultValue);
        const initialized = state[key] !== undefined;
        if (!initialized && value) {
            dispatch('SET_VALUE', { key, value, type });
        }
    }, [defaultValue, dispatch, key, state, type]);
    return [(_a = state[key]) !== null && _a !== void 0 ? _a : defaultValue, setValue];
}
exports.useStorage = useStorage;
